module.exports = __webpack_public_path__ + "static/media/pr_01_A.bd16c913.png";